import { useChat } from '../../../../libs/hooks';
import { AlertType } from '../../../../libs/models/AlertType';
import { useAppDispatch, useAppSelector } from '../../../../redux/app/hooks';
import { RootState } from '../../../../redux/app/store';
import { IConversationDisplayMode } from '../../../../redux/features/app/AppState';
import { addAlert } from '../../../../redux/features/app/appSlice';
import { ConversationHiddenStatusChange } from '../../../../redux/features/conversations/ConversationsState';
import {
    setConversationAsHidden,
    setSelectedConversation,
} from '../../../../redux/features/conversations/conversationsSlice';
import { ModalDialog } from '../ChatWindow/Shared/ModalDialog';

interface IRestoreChatProps {
    chatId: string;
    chatName: string;
    open: boolean;
    onClose: () => void;
}

export const RestoreChatDialog: React.FC<IRestoreChatProps> = ({ chatName, chatId, open, onClose }) => {
    const dispatch = useAppDispatch();
    const { conversations, selectedId } = useAppSelector((state: RootState) => state.conversations);
    const { conversationDisplayMode } = useAppSelector((state: RootState) => state.app);
    const chat = useChat();

    const onRestoreChat = async () => {
        const chatState = conversations[selectedId];
        await chat
            .editChat(chatId, chatName, chatState.memoryBalance, chatState.chatScope, [], false)
            .then(() => {
                dispatch(
                    setConversationAsHidden({ id: chatId, newHiddenState: false } as ConversationHiddenStatusChange),
                );
                if (conversationDisplayMode !== IConversationDisplayMode.All) {
                    dispatch(setSelectedConversation(''));
                }
            })
            .catch((e: Error) => {
                const errorMessage = e instanceof Error ? e.message : String(e);
                throw new Error(errorMessage);
            });
    };

    const handleRestoreChat = () => {
        onRestoreChat().catch((e: Error) => {
            const errorMessage = `Unable to restore chat. Details: ${e instanceof Error ? e.message : String(e)}`;
            dispatch(addAlert({ message: errorMessage, type: AlertType.Error }));
        });
    };

    return (
        <ModalDialog
            title={`Are you sure you want to restore conversation '${chatName}?'`}
            open={open}
            onClose={onClose}
            onAction={handleRestoreChat}
            actionLabel="Restore"
            showCancel>
            <div>Would you like to restore this conversation?</div>
        </ModalDialog>
    );
};
